import { useLocation } from 'react-router';

import { PremiumPlanPurchaseFailedState } from '../../../../../common/interfaces/routerState';
import { makeApolloErrorFromCode } from '../../../../../common/utility';

export default function useGetErrorFromPremiumPlanPurchaseFailedState() {
  const location = useLocation<PremiumPlanPurchaseFailedState | undefined>();

  const { premiumPlanPurchaseFailed } = location.state || {};

  if (!premiumPlanPurchaseFailed) return undefined;

  return {
    error: makeApolloErrorFromCode(premiumPlanPurchaseFailed.failureType),
    product: premiumPlanPurchaseFailed.product,
  };
}
